import { SET_ART_WALL_SCREENSHOT } from './../const';

export default (artWallScreenshot) => {
  return {
    type: SET_ART_WALL_SCREENSHOT,
    artWallScreenshot: artWallScreenshot
  }
};
